import { PeticaoArea } from '@app/models/peticao-area.model';
import { Component, Inject, OnInit, ViewContainerRef } from '@angular/core';

import { PeticaoAreaService } from '@app/services/peticao-area.service';
import { CDSMask } from '@app/utils/cds-mask';
import { Router, ActivatedRoute } from '@angular/router';
import { PeticaoService } from '@app/services/peticao.service';
import { Peticao } from '@app/models/peticao';
import { UtilitarioService } from '@app/services/utilitario.service';
import { ClipboardService } from 'ngx-clipboard';
import { ToastrService } from 'ngx-toastr';
import { ConsultasService } from '@app/services/consultas.service';
import { IdDescricao } from '@app/models/util/id-descricao';
import { AreaService } from '@app/services/area.service';
import { Area } from '@app/models/area';


// import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';


@Component({
  selector: 'app-peticao-form',
  templateUrl: './peticao-form.component.html',
  styleUrls: ['./peticao-form.component.scss']
})
export class PeticaoFormComponent implements OnInit {

  aguardandoSolicitacao = false;
  peticao: Peticao = new Peticao();
  lstAreas: Area[];
  titulo: string;
  lstErros: string[];
  cdsMask = new CDSMask();
  tags: any;
  entrevistaSelecionada: any;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private peticaoService: PeticaoService,
    @Inject(ToastrService) public toastr: ToastrService,
    private utilitarioService: UtilitarioService,
    private clipboardService: ClipboardService,
    private areaService: AreaService
  ) {

  }

  ngOnInit() {

    this.carregaLstAreas();

    // const id = this.route.params.subscribe(params => {
    this.route.params.subscribe(params => {
      const id = params['id'];
      this.titulo = id ? 'Editar Modelo de petição' : 'Novo Modelo de petição';

      // novo
      if (!id) {
        this.peticao.Ativo = true;
      } else {
        // editar
        this.peticaoService.obterPorId(id).toPromise().then(
          data => this.peticao = data,
          () => this.router.navigate(['./peticao'])
        );
      }
    });

    this.peticaoService.obterPorTags(0).toPromise().then(data => this.tags = data);
  }

  carregaLstAreas() {
    this.areaService.obterLista("", 1).toPromise().then(data => {
      this.lstAreas = data;
    });

  }

  alteraArquivo(fileInput: any) {
    if (fileInput.target.files && fileInput.target.files[0]) {
      this.peticao.Arquivo = fileInput.target.files[0];
    }
  }

  onSubmit() {
    this.aguardandoSolicitacao = true;
    if (this.peticao.Id === 0) {
      const dados = UtilitarioService.convertModelToFormData(this.peticao);
      this.peticaoService.adicionar(dados)
        .subscribe(
          () => this.router.navigate(['./peticao/lista']),
          (data: any) => {
            if (data.error) {
              this.lstErros = data.error.errors;
            }
            this.aguardandoSolicitacao = false;
          });
    } else {
      const dados = UtilitarioService.convertModelToFormData(this.peticao);

      this.peticaoService.alterar(dados)
        .subscribe(
          () => this.router.navigate(['./peticao/lista']),
          (data: any) => {
            if (data.error) {
              this.lstErros = data.error.errors;
            }
          });
    }

  }

  public obterArquivo() {
    this.peticaoService.obterArquivo(this.peticao.Id).toPromise().then((data) => {
      this.utilitarioService.saveAs(data, this.peticao.Descricao + this.peticao.Extensao);
    });
  }

  generateArray(obj) {
    return Object.keys(obj).map((key) => ({ key: key, value: obj[key] }));
  }

  onChangeEntrevista(i: any) {
  }

  copied(e: any) {
    this.toastr.info('Tag: ' + e.content + ' copiada');
  }

  copyContent(e: any){
    this.clipboardService.copyFromContent(e)
  }
}
